import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '.././globals';


@Injectable()
export class McqService {

  readonly rootUrl = this._global.siteUrl;

  constructor(private http: HttpClient, private _global: Globals) { }

  // add test paper data
  addtestpaper(tpObj, tpId) {
    const body = { data: tpObj, id: tpId }
    return this.http.post(this.rootUrl + 'mcq/addtestpaper', body);
  }

  // update test paper data
  updatetestpaper(tpObj, tpId) {

    const body = {
      data: tpObj,
      id: tpId,
    }

    return this.http.post(this.rootUrl + 'mcq/updatetestpaper', body);
  }

  // get test paper data 
  gettestpaperlist(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/gettestpaperlist', Obj, { headers: reqHeader });
  }

  // get test paper data 
  gettestpaperdata(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/gettestpaperdata', Obj, { headers: reqHeader });
  }


  //del test paper data
  deltestpaper(tpId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/deletetestpaper', tpId, { headers: reqHeader });
  }

  // get test paper data 
  getQuestionList(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getQuestionList', Obj, { headers: reqHeader });
  }

  // save student's answers
  saveStudentAnswers(Obj) {
    return this.http.post(this.rootUrl + 'mcq/saveStudentAnswers', Obj);
  }

  // save student's answers
  saveStudentAnswersAll(Obj) {
    return this.http.post(this.rootUrl + 'mcq/saveStudentAnswersAll', Obj);
  }

  // get daily quiz report list of a logged in student
  getStudentDailyQuizReportList(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentDailyQuizReportList', Obj, { headers: reqHeader });
  }

  // get daily quiz report per paper wise of a logged in student
  getStudentReportIdWise(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentReportIdWise', Obj, { headers: reqHeader });
  }

  getFormatTime(seconds) {
    let m = Math.floor(seconds / 60);
    let rh = Math.floor(m % 60);
    return this.pad(Math.floor(seconds / 3600)) + ':' + this.pad(Math.floor(rh)) + ':' + this.pad(Math.floor(seconds % 60));
  }

  // ADD PREFIX 0 TO SINLGE DIGIT NUMBER
  pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  // get only all section name of a paper
  getSectionNamePaperWise(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getSectionNamePaperWise', Obj, { headers: reqHeader });
  }

  // get student paper report section wise
  getSectionWiseReport(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getSectionWiseReport', Obj, { headers: reqHeader });
  }

  // get difficulty level report 
  getDifficutyLevelReport(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getDifficutyLevelReport', Obj, { headers: reqHeader });
  }

  // get student paper report section wise
  getStudentQuizList(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentQuizList', Obj, { headers: reqHeader });
  }

  // get list of all question and test paper detail for quiz
  getDetailsForStartQuiz(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getDetailsForStartQuiz', Obj, { headers: reqHeader });
  }

  //del mains test series
  delFile(obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/deleteFiles', obj, { headers: reqHeader });
  }

  getBatchByCenter(centerId) {
    return this.http.get(this.rootUrl + 'session/getbatchByCenter?cid=' + (centerId));
  }

  addquizsection(Obj) {

    return this.http.post(this.rootUrl + 'mcq/addquizsection', Obj);
  }
  editquizsection(Obj) {

    return this.http.post(this.rootUrl + 'mcq/editquizsection', Obj);
  }
  papersectionlist(Obj) {
    const body = {
      start: Obj[0],
      end: Obj[1],
      search: Obj[2],
      status: Obj[3],
    }
    return this.http.post(this.rootUrl + 'mcq/quizsectionlist', body);

  }
  editsection(Id) {
    const body = {
      id: btoa(Id),
    }

    return this.http.post(this.rootUrl + 'mcq/getquizsection', body);
  }

  delsection(id) {
    const body = {
      id: id,
      isDeleted: 1,

    }
    return this.http.post(this.rootUrl + 'mcq/delquizsection', body);
  }

  // add/update question
  addquestion(tpObj, tpId) {
    const body = { data: tpObj, id: tpId }
    return this.http.post(this.rootUrl + 'mcq/addquestion', body);
  }

  // get test paper data 
  getquestion(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getquestion', Obj, { headers: reqHeader });
  }

  //del test paper data
  deleteQuestion(qId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/deleteQuestion', qId, { headers: reqHeader });
  }

  //del test paper all question of a section
  deleteSection(qId) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/deleteSection', qId, { headers: reqHeader });
  }

  // comprison report
  getTopTenStudentsReport(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getTopTenStudentsReport', Obj, { headers: reqHeader });
  }

  // Get data of solution report section
  getSolutionReport(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getSolutionReport', Obj, { headers: reqHeader });
  }

  // Get data of solution report section
  updateSrNo(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/updateSrNo', Obj, { headers: reqHeader });
  }

  // Get student count of all currect answers of a paper
  getStudentQuestionWiseCount(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentQuestionWiseCount', Obj, { headers: reqHeader });
  }

  // Get student count of all currect answers of a paper
  getQuizReportListAdmin(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getQuizReportListAdmin', Obj, { headers: reqHeader });
  }

  // 
  getQuestionBankData(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getQuestionBankData', Obj, { headers: reqHeader });
  }

  // 
  getTestPaperShortList(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getTestPaperShortList', Obj, { headers: reqHeader });
  }

  // 
  addQuestionFromBank(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/addQuestionFromBank', Obj, { headers: reqHeader });
  }

  // get test paper data 
  getStudentAppearInExam(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentAppearInExam', Obj, { headers: reqHeader });
  }


  getteststreams(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(this.rootUrl + 'mcq/getteststreams', { headers: reqHeader });
  }

  // get student paper report section wise
  getStudentAttempt(Obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/getStudentAttempt', Obj, { headers: reqHeader });
  }

  // 
  uploadQuestions(Obj) { 
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'mcq/uploadQuestions', Obj, { headers: reqHeader });
  }

  getOverAllReportAdmin(Obj) { 
    var reqHeader = new HttpHeaders({ 'No-Auth': 'False' });
    return this.http.post(this.rootUrl + 'mcq/getOverAllReportAdmin', Obj, { headers: reqHeader });
  }

  getQuestionDifficultyLevel(Obj) { 
    var reqHeader = new HttpHeaders({ 'No-Auth': 'False' });
    return this.http.post(this.rootUrl + 'mcq/getQuestionDifficultyLevel', Obj, { headers: reqHeader });
  }

  updateAllQuestions(tpObj,tpId){ 
    const body = { data: tpObj, id: tpId }
    return this.http.post(this.rootUrl + 'mcq/updateAllQuestions', body); 
    }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/mcq.service.ts